import { render } from "./CRM_Customer_Dialog.vue?vue&type=template&id=e85e37fc&scoped=true"
import script from "./CRM_Customer_Dialog.vue?vue&type=script&lang=js"
export * from "./CRM_Customer_Dialog.vue?vue&type=script&lang=js"

import "./CRM_Customer_Dialog.vue?vue&type=style&index=0&id=e85e37fc&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e85e37fc"]])

export default __exports__